import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { ScreeningInsightsResponse } from '@estercare/ester-shared'
import { theme } from '../../../../theme/theme'
import { MetricTile } from './MetricTile'

type ShareOfScreened = NonNullable<ScreeningInsightsResponse['severeScreenings']>

type Props = {
  /** Absent when the API suppressed it; the tile still renders, saying so. */
  severeScreenings?: ShareOfScreened
  careNeedLevel3?: ShareOfScreened
}

export const KeyMetricTiles = ({ severeScreenings, careNeedLevel3 }: Props) => {
  const { t } = useTranslation()
  const percent = (pct: number) => t('admin.statistics.percentValue', { value: Math.round(pct) })

  return (
    <TileStack>
      <MetricTile
        title={t('admin.statistics.severityTitle')}
        value={severeScreenings && percent(severeScreenings.pct)}
      />
      <MetricTile title={t('admin.statistics.careLevelTitle')} value={careNeedLevel3 && percent(careNeedLevel3.pct)} />
    </TileStack>
  )
}

const TileStack = styled.div`
  display: grid;
  gap: ${theme.spacing.medium}px;

  @media screen and (max-width: ${theme.breakpoint.large}px) {
    gap: ${theme.spacing.small}px;
  }
`
